const slides = document.querySelectorAll('.review-list__container .swiper-slide');
const totalSlides = slides.length;
const middleSlide = Math.floor(totalSlides / 2);

const swiper = new Swiper("#review-list-mobile", {
	slidesPerView: 'auto',
	speed: 500,
	spaceBetween: 16,
	initialSlide: 1,
	centeredSlides: true,
	watchOverflow: true,
});

const swiperDesktop = new Swiper("#review-list-desktop", {
	slidesPerView: 'auto',
	speed: 500,
	spaceBetween: 16,
	watchOverflow: true,
});

// document.addEventListener('DOMContentLoaded', () => {
// 	const section = document.getElementById('review-list-desktop');
// 	const button = document.getElementById('slider-button');
//
// 	button.addEventListener('click', () => {
// 		section.classList.toggle('expanded');
// 		button.parentElement.classList.toggle('expanded');
// 	});
// });